import { dew as _parseAccountDew } from "../../accounts/utils/parseAccount.js";
import { dew as _estimateFeesPerGasDew } from "../../actions/public/estimateFeesPerGas.js";
import { dew as _estimateGasDew } from "../../actions/public/estimateGas.js";
import { dew as _getBlockDew } from "../../actions/public/getBlock.js";
import { dew as _getTransactionCountDew } from "../../actions/public/getTransactionCount.js";
import { dew as _accountDew } from "../../errors/account.js";
import { dew as _feeDew } from "../../errors/fee.js";
import { dew as _getActionDew } from "../../utils/getAction.js";
import { dew as _assertRequestDew } from "../../utils/transaction/assertRequest.js";
import { dew as _getTransactionTypeDew } from "../../utils/transaction/getTransactionType.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.prepareTransactionRequest = void 0;
  const parseAccount_js_1 = _parseAccountDew();
  const estimateFeesPerGas_js_1 = _estimateFeesPerGasDew();
  const estimateGas_js_1 = _estimateGasDew();
  const getBlock_js_1 = _getBlockDew();
  const getTransactionCount_js_1 = _getTransactionCountDew();
  const account_js_1 = _accountDew();
  const fee_js_1 = _feeDew();
  const getAction_js_1 = _getActionDew();
  const assertRequest_js_1 = _assertRequestDew();
  const getTransactionType_js_1 = _getTransactionTypeDew();
  async function prepareTransactionRequest(client, args) {
    const {
      account: account_ = client.account,
      chain,
      gas,
      nonce,
      type
    } = args;
    if (!account_) throw new account_js_1.AccountNotFoundError();
    const account = (0, parseAccount_js_1.parseAccount)(account_);
    const block = await (0, getAction_js_1.getAction)(client, getBlock_js_1.getBlock, "getBlock")({
      blockTag: "latest"
    });
    const request = {
      ...args,
      from: account.address
    };
    if (typeof nonce === "undefined") request.nonce = await (0, getAction_js_1.getAction)(client, getTransactionCount_js_1.getTransactionCount, "getTransactionCount")({
      address: account.address,
      blockTag: "pending"
    });
    if (typeof type === "undefined") {
      try {
        request.type = (0, getTransactionType_js_1.getTransactionType)(request);
      } catch {
        request.type = typeof block.baseFeePerGas === "bigint" ? "eip1559" : "legacy";
      }
    }
    if (request.type === "eip1559") {
      const {
        maxFeePerGas,
        maxPriorityFeePerGas
      } = await (0, estimateFeesPerGas_js_1.internal_estimateFeesPerGas)(client, {
        block,
        chain,
        request: request
      });
      if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new fee_js_1.MaxFeePerGasTooLowError({
        maxPriorityFeePerGas
      });
      request.maxPriorityFeePerGas = maxPriorityFeePerGas;
      request.maxFeePerGas = maxFeePerGas;
    } else {
      if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new fee_js_1.Eip1559FeesNotSupportedError();
      const {
        gasPrice: gasPrice_
      } = await (0, estimateFeesPerGas_js_1.internal_estimateFeesPerGas)(client, {
        block,
        chain,
        request: request,
        type: "legacy"
      });
      request.gasPrice = gasPrice_;
    }
    if (typeof gas === "undefined") request.gas = await (0, getAction_js_1.getAction)(client, estimateGas_js_1.estimateGas, "estimateGas")({
      ...request,
      account: {
        address: account.address,
        type: "json-rpc"
      }
    });
    (0, assertRequest_js_1.assertRequest)(request);
    return request;
  }
  exports.prepareTransactionRequest = prepareTransactionRequest;
  //# sourceMappingURL=prepareTransactionRequest.js.map
  return exports;
}